import React, { useContext } from 'react';
import { Form } from 'semantic-ui-react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { createFormFieldRowKey } from './DynamicFormFields.utils';
import { DynamicFormContext } from '../../../context/DynamicFormContext';
import DynamicFormField from '../DynamicFormField';
function DynamicFormFields() {
  var _useContext = useContext(DynamicFormContext),
    componentConfigurationId = _useContext.componentConfigurationId,
    formData = _useContext.formData,
    fields = _useContext.fields;
  if (_isEmpty(fields)) {
    return null;
  }
  var formFields = fields.map(function (formFieldRow) {
    var rowKey = createFormFieldRowKey(componentConfigurationId, formFieldRow);
    return /*#__PURE__*/React.createElement(Form.Group, {
      widths: "equal",
      key: rowKey
    }, formFieldRow.map(function (field) {
      var name = field.name;
      var value = _get(formData, name);
      return /*#__PURE__*/React.createElement(DynamicFormField, {
        field: field,
        value: value,
        key: name
      });
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, formFields);
}
export default DynamicFormFields;